BoardSelectOrganizationView = require 'views/board-menu/board-select-organization-view'

module.exports = class BoardAddToOrganizationView extends BoardSelectOrganizationView

  viewTitleKey: 'add to a team'

  getTemplateData: ->
    data = super()
    data.addToTeam = true

    return data



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-add-to-organization-view.coffee